import { PageWrapper } from "@/components";
import { CategoryTypeHeaderItem } from "@/components/DynamicForm/styled";
import {
  PendingIntakeApprovalsPreview,
  PendingMilestoneApprovalsPreview,
  RecentlyApprovedIntakePreview,
  RecentlyApprovedMilestonesPreview,
  RoutingMilestoneApprovalsPreview,
} from "@/containers/Dashboard/Previews";
import { CONTENT_WIDTH as GRID_SIZES, GUTTER_SIZE } from "@/enums";
import { routes } from "@/helpers";
import { useAllRights } from "@/hooks";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "antd";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const rights = useAllRights();

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({ id: "home.dashboard.title" })}
      noBackButton
    >
      <Row gutter={GUTTER_SIZE.large} justify="space-between" align="top">
        <Col>
          <CategoryTypeHeaderItem>
            {intl.formatMessage({
              id: "dashboard.titles.myDashboard",
            })}
          </CategoryTypeHeaderItem>
        </Col>
        {rights.canCreateIntake && (
          <Col xxs={GRID_SIZES.half}>
            <Button
              data-test-id="project-list-add-intake"
              type="primary"
              onClick={() => navigate(routes.projects.new)}
              icon={<FontAwesomeIcon icon={faCirclePlus} />}
            >
              {intl.formatMessage({ id: "projectIntake.create" })}
            </Button>
          </Col>
        )}
      </Row>
      <Row gutter={GUTTER_SIZE.small}>
        <PendingIntakeApprovalsPreview />
        <PendingMilestoneApprovalsPreview />
        <RecentlyApprovedIntakePreview />
        <RecentlyApprovedMilestonesPreview />
        <RoutingMilestoneApprovalsPreview />
      </Row>
    </PageWrapper>
  );
};

export default Dashboard;
